import { updateLanguage } from "@/api/query/language";
import Loading from "@/common/components/Loading";
import PopUp from "@/common/components/PopUp";
import SelectInput from "@/common/components/custom/SelectInput";
import CustomSaveButton from "@/common/components/custom/buttons/CustomSaveButton";
import { MessageContext } from "@/common/contexts/message.context";
import React, { useContext, useState } from "react";
import { useMutation } from "react-query";
import { styled } from "styled-components";
import VoiceConfigTable from "./VoiceConfigTable";

const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  min-width: 760px;
`;

const Title = styled.h3``;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: right;
`;

const AdminVoiceEdit = ({ edit, setEdit, languages }) => {
  const { addMessage } = useContext(MessageContext);
  const [selectedLanguage, setSelectedLanguage] = useState(
    edit.language ? { label: edit.language.name, value: edit.language } : null
  );
  const [voices, setVoices] = useState(
    edit.voice
      ? [edit.voice]
      : edit.language?.voices || []
  );

  const languageOptions = languages.map((language) => ({
    label: language.name,
    value: language,
  }));

  const updateLanguageMutation = useMutation({
    mutationFn: (value) => updateLanguage(value),
    onSuccess: () => {
      setEdit(null);
    },
    onError: () => {
      addMessage("Could not save voice config", "error");
    },
  });

  const handleLanguageChange = (option) => {
    setSelectedLanguage(option);
    setVoices(option?.value?.voices || []);
  };

  const handleSave = (e) => {
    e && e.preventDefault();

    if (!selectedLanguage?.value) {
      return addMessage("Select language", "error");
    }

    const hasIncompleteVoice = voices.some(
      (voice) => !voice.languageCode || !voice.name
    );

    if (hasIncompleteVoice) {
      return addMessage("Fill google voice config", "error");
    }

    const payload = {
      ...selectedLanguage.value,
      voices,
    };

    updateLanguageMutation.mutate(payload);
  };

  return (
    <>
      {updateLanguageMutation.isLoading && <Loading />}
      <PopUp setClose={setEdit}>
        <Title>{edit.voice ? "Edit" : "Add"} voice</Title>
        <Wrapper onSubmit={handleSave} autoComplete="new-password">
          <SelectInput
            width={140}
            selectWidth={260}
            name="Language"
            options={languageOptions}
            selected={selectedLanguage}
            setSelected={handleLanguageChange}
          />
          <VoiceConfigTable voices={voices} setVoices={setVoices} />
          <ButtonWrapper>
            <CustomSaveButton />
          </ButtonWrapper>
        </Wrapper>
      </PopUp>
    </>
  );
};

export default AdminVoiceEdit;
